// Category management service
import {
  collection,
  doc,
  getDoc,
  getDocs,
  setDoc,
  updateDoc,
  query,
  where,
  orderBy,
  serverTimestamp
} from 'firebase/firestore';
import { db } from '../firebase/config';
import { v4 as uuidv4 } from 'uuid';

// Create a new category
export const createCategory = async (competitionId, name, order = 0, icon = '🎲', color = '#3B82F6') => {
  const categoryId = uuidv4();
  const categoryRef = doc(db, 'categories', categoryId);

  const category = {
    competitionId,
    name: name.trim(),
    icon,
    color,
    status: 'active',
    order,
    createdAt: serverTimestamp()
  };

  await setDoc(categoryRef, category);

  return {
    id: categoryId,
    ...category
  };
};

// Get category by ID
export const getCategory = async (categoryId) => {
  const categoryRef = doc(db, 'categories', categoryId);
  const categorySnap = await getDoc(categoryRef);

  if (!categorySnap.exists()) {
    return null;
  }

  return {
    id: categorySnap.id,
    ...categorySnap.data()
  };
};

// Get all categories for a competition
export const getCategoriesForCompetition = async (competitionId) => {
  const categoriesRef = collection(db, 'categories');
  const q = query(
    categoriesRef,
    where('competitionId', '==', competitionId),
    orderBy('order', 'asc')
  );
  const querySnapshot = await getDocs(q);

  return querySnapshot.docs.map(doc => ({
    id: doc.id,
    ...doc.data()
  }));
};

// Get active categories for a competition
export const getActiveCategories = async (competitionId) => {
  const categoriesRef = collection(db, 'categories');
  const q = query(
    categoriesRef,
    where('competitionId', '==', competitionId),
    where('status', '==', 'active'),
    orderBy('order', 'asc')
  );
  const querySnapshot = await getDocs(q);

  return querySnapshot.docs.map(doc => ({
    id: doc.id,
    ...doc.data()
  }));
};

// Update category
export const updateCategory = async (categoryId, updates) => {
  const categoryRef = doc(db, 'categories', categoryId);
  await updateDoc(categoryRef, {
    ...updates,
    updatedAt: serverTimestamp()
  });
};

// Deactivate category
export const deactivateCategory = async (categoryId) => {
  await updateCategory(categoryId, { status: 'deactivated' });
};

// Reorder categories
export const reorderCategories = async (categoryUpdates) => {
  const promises = categoryUpdates.map(({ categoryId, order }) =>
    updateCategory(categoryId, { order })
  );
  await Promise.all(promises);
};
